import { Controller } from "stimulus";

export default class extends Controller {
  filterByUrl(e) {
    const params = e.currentTarget.dataset.params
    const url = `${window.location.pathname}?type=${params}`;

    Turbolinks.clearCache();
    Turbolinks.visit(url);
  }
}
